import { ModalFeatures } from 'api/contentful/contentTypes.cloverdotcom';
import React, { FC } from 'react';
import { FeaturesModalHeader } from './FeaturesModalHeader/FeaturesModalHeader';
import { FeaturesModalBody } from './FeaturesModalBody/FeaturesModalBody';
import { StructuredModal, StructuredModalState } from 'components/StructuredModal/StructuredModal';
import cx from 'classnames';
import styles from './FeaturesModal.module.scss';
import { FlatEntry } from 'services/cms/flattenContentful';

interface IDetailedModalFeaturesProp {
  entries?: FlatEntry<ModalFeatures>;
  modalState: StructuredModalState;
}

export const FeaturesModal: FC<IDetailedModalFeaturesProp> = ({ entries, modalState }) => {
  if (!entries) return null;

  return (
    <StructuredModal
      modalState={modalState}
      aria={{ modal: true, labelledby: 'detailsModal' }}
      className={styles.modal}
    >
      <div className={cx(styles.modalContent)}>
        <FeaturesModalHeader entries={entries} />
        <FeaturesModalBody features={entries.features} />
      </div>
    </StructuredModal>
  );
};
